import { render, staticRenderFns } from "./rightofferBox.vue?vue&type=template&id=40112cf2"
import script from "./rightofferBox.vue?vue&type=script&lang=js"
export * from "./rightofferBox.vue?vue&type=script&lang=js"
import style0 from "./rightofferBox.vue?vue&type=style&index=0&id=40112cf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports